<template>
    <div class="delivery-view-corpo">

        <MenuTopTemplate :titulo="'DELIVERY'" :icone="require('../assets/icons/delivery-preto.png')" :onPressedClose="voltar"/>

        <div v-if="loading && !pedidoEnviado" class="center img-loading-container">
            <img src="../assets/loading.gif" alt="" class="img-loading">
        </div>
 
        <!-- para testar -->
        <!-- <button @click="() => {this.onSubmitPagamentoMp('debit')}">pix</button> -->

        <div v-if="!loading && pedidoEnviado && this.tipoPagamento.pagamentoId != 'web pix'">
            <DeliverySucessoView/>
        </div>

        <div v-if="!loading && !pedidoEnviado">
            <TelefoneComDDD @callback="enviarTelefone" :mostrar="true" :loadingEnviarTelefone="this.loadingTelefone" :whiteBackground="false" :numeroTel="telefone"/>

            <h2 style="margin:0px">Dados para {{this.retirarNoLocal?'retirada':'entrega'}}</h2>

            <div v-if="voltouRespostaTelefone && !clienteExistente" class="card">
                <p style="font-weight: bold;">Parece que você ainda não tem cadastro conosco!!</p>  
                <p>Por favor, entre com seus dados abaixo para que possamos realizar sua entraga!</p>
            </div>           

    <!-- form para preencher endereco  -->    
            <div v-if="voltouRespostaTelefone">
            
    <!-- endereco ou tirar no local  -->
                <div v-if="clienteExistente">
                    <div class="card">
                        <div>
                            <ControleEnderecos :enderecos="todosEnderecos" @callback="callbackEnderecoController" :nome="dadosClienteApi.nome" @enderecosAtualizados="onEnderecosAtualizados"/>
                        </div>

                        <!-- testar cpf do cliente -->
                        <!-- <div style="background-color: blueviolet; color: white;">{{  JSON.stringify(this.$store.state.cpfCliente)  }}</div> -->
                    </div>
                </div>

    <!-- endereco cado cliente nao exista -->
                <div v-if="!clienteExistente">
                    <DadosEndereco  :exigirNome="false" :telefoneCliente="this.telefone"/>
                </div>

    <!-- mensagem nao pode enviar pedido  -->
                <div class="card" v-if="this.$store.state.deliveryTaxas == 'erro' && !retirarNoLocal && this.casaFechada == false">
                    <p>Desculpe! Infelizmente nós ainda não fazemos entregas para este bairro.</p>
                </div>

    <!-- mensagem a casa esta fechada  -->
                <div class="card" style="border: solid 5px red" v-if="this.casaFechada == true">
                    <p>Desculpe! Infelizmente este estabelecimento está fechado no momento para pedidos delivery.</p>
                </div>
                
                <!-- resumo -->
                <div class="card" v-if="this.$store.state.deliveryTaxas != 'erro'">
                    <div style="display: flex; align-items: center;" @click="onClickIncluirCpfNaNota()">
                        <img src="../assets/icons/ic-unchecked.svg" alt="" class="click-ic" style="height: 20px; filter: invert(100%);" v-if="!incluirCpfNaNota">
                        <img src="../assets/icons/ic-checked.svg" alt="" class="click-ic" style="height: 20px; filter: invert(100%);" v-if="incluirCpfNaNota">
                        <p style="font-size: 12px;">incluir o CPF {{ cpfCliente }} na nota fiscal.</p>
                    </div>
                
                    <!-- <br> -->
                    <!-- <button @click="onErrorPagamentoMp">Erro</button> -->
                    <div class="resumo-pedido">
                        <span>
                            <p>Valor do pedido:</p>
                            <p class="valor-pedido"> {{ valoresEmReais.pedido }}</p>
                        </span>
                        <div v-if="!retirarNoLocal">
                            <span>
                                <p>Taxa de entrega:</p>
                                <p class="valor-taxa"> {{ valoresEmReais.entrega }}</p>
                            </span>
                            <hr>
                            <span>
                                <p>Valor total:</p>
                                <p class="valor-total"> {{ valoresEmReais.total }}</p>
                            </span>
                            <!-- justify-content: space-between; -->
                            <!-- <div style="text-align: start;display: flex;justify-content: space-between;">
                                <p >Tempo estimado de entrega:</p>
                                <p class="valor-tempo-entrega">{{ this.taxaDeEntrega.TempoMedioEntrega  }} min</p>
                            </div> -->
                        </div>
                    </div>
                </div>
                    
                <div v-if="aceitaRetirada||aceitaEntrega">

                     <!-- tipo de pagamento            -->
                     <div v-if="this.casaFechada == false && (this.$store.state.deliveryTaxas != 'erro' || retirarNoLocal)">
                         <TipoPagamento @callback="callbackTipoPagamento" :valorTotalPedidoMaisTaxa="valorTotal()" @pagarPeloAppSelecionado="(val) => {this.pagarPeloApp = val}" :retirar-no-local="retirarNoLocal">
                             <!-- botao enviar pedido  -->
                             <div v-if="!pagarPeloApp">
                                 <div v-if="this.$store.state.deliveryTaxas != 'erro' || retirarNoLocal ">
                                     <p v-if="!podeEnviarPedido" style="color: red; font-size: 12px;margin-top: 15px;">Para poder enviar o pedido, verifique se realizamos entregas no bairro escolhido e verifique se um método de pagamento foi selecionado </p>
                                     <div v-if="habilitarBotaoEnviar">
                                         <button v-if="!podeEnviarPedido" class="btn-normal" style="background: grey;margin-top: 5px;">Enviar pedido</button>
                                         <button :style="{ color :'white', background:'var(--azul-claro)', marginTop:'20px'}" v-if="podeEnviarPedido" class="btn-normal" @click="enviarPedido">Enviar pedido</button>
                                     </div>
                                 </div>
                             </div>
                         </TipoPagamento>
                     </div>


                    <!-- Pagamento Mercado Pago -->
                    <!-- vamos dar um tempinho antes de carregar o mp aqui so pra termos certeza que o preco ja foi calculado corretamente antes de criamos o bricks -->
                    <!-- esse tempinho vai ser contado no created() e controlado pela var this.iniciarMercadoPago -->
                    <!-- vamos mostrar um placeholder enquanto carrega esse tempinho  -->
                    <div >
                        <div v-if="this.iniciarMercadoPago  && this.casaFechada == false && pagarPeloApp && this.$store.state.mp_public_key != null && (this.$store.state.deliveryTaxas != 'erro' || retirarNoLocal)">
                            <mp-pagamento 
                            :total="this.valorTotal()"
                            :pedido="this.montarPedidoFinal()"
                            @onSubmit="onSubmitPagamentoMp"
                            @onError="onErrorPagamentoMp"
                            />
                        </div>

                        <!-- placeholder  -->
                        <div v-if="!this.iniciarMercadoPago  && this.casaFechada == false && pagarPeloApp && this.$store.state.mp_public_key != null && (this.$store.state.deliveryTaxas != 'erro' || retirarNoLocal)">
                            <div id="mp-placeholder"> 
                                <img src="../assets/loading.gif" alt="">
                            </div>
                        </div>
                    </div>

                 </div> 


            </div> 


            <div style="margin-bottom: 100px;">
                
            </div>
        </div>


    </div> 
</template>

<script>
import MenuTopTemplate from "@/components/Base/MenuTopTemplate.vue";
import ApiDelivery, {} from "../api/ApisDelivery"
// import PedidoModel from '@/model/pedidoModel'; 
// import apiEnviarPedido from '@/api/ApiEnviarPedido';  
import TelefoneComDDD from '@/components/Delivery/TelefoneComDDD.vue';
import DadosEndereco from "@/components/Delivery/DadosEndereco.vue";
import ControleEnderecos from "@/components/Delivery/ControleEnderecos.vue";
import TipoPagamento from "@/components/Delivery/TipoPagamento.vue";
import Swal from 'sweetalert2';
import DeliverySucessoView from "./DeliverySucessoView.vue";
// eslint-disable-next-line no-unused-vars
import { converterParaDinheiroString } from "@/utils/Dinheiro";
import { setarCores } from '@/utils/SetarCores';
import MpPagamento from '@/components/mercadopago/MpPagamento.vue';
import MpStatusScreenPix from '@/components/mercadopago/MpStatusScreenPix.vue';
import { gerarIdUnico } from "@/utils/GerarIdUnico";
export default {
    name: "DeliveryView",

    props: {
        // pedido: PedidoModel  
    },
    // In your 'delivery' component
    mounted() {
        // const data = this.$route.params;      // Access the data using the key you specified
        // const dataq = this.$route.query;      // Access the data using the key you specified
    },

	watch: {
        pagarPeloApp() {
            console.log("%c mudou aqui", 'background: yellow')
            this.iniciarMercadoPago = false
            setTimeout(() => {
                console.log("COMECEI O MERCADO PAGO")
                this.iniciarMercadoPago = true
            }, 2000);

        },
        '$store.state.deliveryRetirarNoLocal'(val) {
            this.retirarNoLocal = val
        },
	},

    data() {
        return {
            loading: false,
            loadingTelefone: false,
            loadingCep: false,
            telefone: "",
            casaFechada: true,
            iniciarMercadoPago: false,
          
            nomeCliente: "",
            voltouRespostaTelefone: false,
            clienteExistente: false,
            cep: "", 
            
            /**@type {EnderecoModel} */
            endereco: null,
            todosEnderecos: [],
            dadosClienteApi: null,
 
            // dados de callback
            tipoPagamento: null,
            retirarNoLocal: this.$store.state.deliveryRetirarNoLocal,

            pedidoEnviado: false,

            dataagora: Date(),

            habilitarBotaoEnviar: true,
            
            incluirCpfNaNota: false,

            pagarPeloApp: this.$store.state.mp_public_key != null && (this.$store.state.mp_tem_pix || this.$store.state.mp_tem_cartao),

            /** 
             * Objeto que volta da classe @see MpPagamento caso o usuario tenha escolhido pagar por pix.
             * Vai ser populado pela funcao @see this.onSubmitPagamentoMp para ser enviado de volta
             * para o Allfood. Caso o pagamento seja por caratao, essa var vai como objeto vazio {} .
             */
            pixPaymentObjEnviarComPedido: {},

            aceitaRetirada:this.$store.state.deliveryAceitaRetirada,
            aceitaEntrega:this.$store.state.deliveryAceitaEntrega,

        };
    }, 

    
    created() {
        this.verficiarSeACasaEstaAberta();
        setarCores(this.$store.state.cor1, this.$store.state.cor2, this.$store.state.corTexto)

        setTimeout(() => {
            console.log("COMECEI O MERCADO PAGO")
            this.iniciarMercadoPago = true
        }, 2000);
    },

    

    computed: {
        cpfCliente(){
            const cpf = this.$store.state.cpfCliente;
            if (cpf) {
                return cpf.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, "$1.$2.$3-$4");
            } else {
                return ""
            }
        },
        
        pedido() {
            return this.$store.state.deliveryPedido;
        },

        taxaDeEntrega() {
            return this.$store.state.deliveryTaxas; 
        },

        podeEnviarPedido() {
            if (this.casaFechada) {
                console.log("a casa esta fechada, nao pode enviar pedido")
                return false;
            }
            if (this.tipoPagamento == null) {
                console.log("tipo de pagamento nulo, nao pode enviar pedido")
                return false;
            } else {
                if (this.$store.state.deliveryRetirarNoLocal) {
                    console.log("retirar no local, pode enviar pedido")
                    return true
                } else {
                    if (this.$store.state.deliveryTaxas == null) {
                        console.log("taxa de entrega nula, nao pode enviar pedido")
                        return false 
                    }
                    console.log("tudo certo, pode enviar pedido")
                    return true
                }
            }
        },

        valoresEmReais() {
            return {
                pedido: converterParaDinheiroString(this.pedido.valorTotalCarrinho),
                entrega: converterParaDinheiroString(this.taxaDeEntrega?.TaxaEntrega),
                total: converterParaDinheiroString(this.valorTotal()),        
            }
        }
    },

    methods: { 


        buscarDados() {},

        onEnderecosAtualizados(enderecosAtualizados) {
            this.todosEnderecos = enderecosAtualizados
        },

        onClickIncluirCpfNaNota() {
            this.incluirCpfNaNota = !this.incluirCpfNaNota;
        },

        verficiarSeACasaEstaAberta() {
            this.loading = true;
            ApiDelivery.verificarCasaEstaAbertaAgora(this.$store.state.cnpj, this.$store.state.numeroEmpresaFK, this.$store.state.idTerminal)
            .then((res) => {
                console.log(res)
                this.casaFechada = false;

            })
            .catch((err) => {
                console.log(err)
                this.casaFechada = true;
            })
            .finally(() => {
                this.loading = false;
            })
        },

        valorTotal() {
            if (this.$store.state.deliveryTaxas && this.$store.state.deliveryTaxas?.TaxaEntrega) {
                if (this.retirarNoLocal) {
                    return this.$store.state.deliveryPedido.valorTotalCarrinho
                }
                return this.$store.state.deliveryPedido.valorTotalCarrinho + this.$store.state.deliveryTaxas?.TaxaEntrega
            }
            return this.$store.state.deliveryPedido.valorTotalCarrinho
        },


        async enviarTelefone22(dados) {
            console.log("êeenviarndo telefone")
            this.loadingTelefone = true;
            let telefone = dados.telefone
            try {
                let res = await this.$store.dispatch("enviarTelefone", telefone)
                this.clienteNovoTelefone = telefone;
                this.clienteExistente = true;
                this.voltouRespostaTelefone = true;
                this.todosEnderecos = res.dadosEnderecos
                this.dadosClienteApi = res.dadosPessoais 
            } catch (error) {
                console.log("deu aqui meu maninho")
                if (error == 501) {  
                    this.clienteNovo = true
                    this.clienteNovoTelefone = telefone
                }
                if (error == 2424) {
                    console.log("deu aqui erro 2424 meu mano segundo")
                    console.log(error, error)
                    this.clienteNovo = true
                    this.clienteNovoTelefone = telefone
                }
                console.log(error, error)


                /** vamos navegar para a pagina de cadastro de endereco */
                this.$router.push({
                    path: "/deliveryendereco",
                    query: { novo:true, telefone: this.telefone },
                })
            } finally {
                this.loadingTelefone = false;
                this.voltouRespostaTelefone = true;
            }
   
        },

        buscarTaxasDeEntrega() {
            const state = this.$store.state
            const taxasDeEntregaPromises = this.todosEnderecos.map((end) => {
                return ApiDelivery.buscarTaxaDeEntrega(state.cnpj, state.numeroEmpresaFK, end.bairro)
                    .then(tax => tax)
                    .catch(err2 => {
                        console.log(err2);
                        return 'erro'
                    })
            })

            Promise.all(taxasDeEntregaPromises).then((taxasDeEntrega) => {
                console.log("AQUI ESTAO AS TAXAS DE ENTREGA")
                console.log(taxasDeEntrega)
                this.$store.dispatch("setDeliveryTaxasDeTodosEnderecos", taxasDeEntrega)

                const bairroAtual = this.$store.state.deliveryEndereco.bairro
                const taxaDoEnderecoSelecionado = taxasDeEntrega.find(t => t && String(t.Nome).toUpperCase() === String(bairroAtual).toUpperCase())
                console.log("AQUI ESTA A TAXA DO ENDERECO SELECIONADO")
                console.log(taxaDoEnderecoSelecionado)
                this.$store.dispatch("setDeliveryTaxas", taxaDoEnderecoSelecionado || null)
            })
        },

        enviarTelefone(dados) {
            
            this.telefone = dados.telefone;
            if (this.telefone.length < 12 && this.telefone.length > 9) {
                if (!this.loadingTelefone) {
                    this.loadingTelefone = true;

                    ApiDelivery.buscarCliente(this.$store.state.cnpj, this.telefone)
                    
                        /** caso nao retorne erro, entao o cliente ja esta cadastrado. O retorno sera os dados do cliente */
                        .then(res => {
                            console.log('CONSOLO GAY AQUI')
                            // preciso guardar o vetor em outra variavel e deixar um unico para a taxaDoEndereçoSelecionado
                            console.log(res)
                            console.log(this.retirarNoLocal)
                            this.loadingTelefone = false;
                            this.voltouRespostaTelefone = true;
                            this.clienteExistente = true;
                            this.dadosClienteApi = res.dadosPessoais 
                            this.$store.dispatch('setCpfCliente',res.dadosPessoais.cpf);
                            this.$store.dispatch('setNomeCliente',res.dadosPessoais.nome);
                            
                            // sempre carregar os enderecos, independentemente do modo
                            this.todosEnderecos = res.dadosEnderecos
                            /** Vamos pegar o endereço(se tiver), mesmo que seja retirada no local. porque o cliente pode mudar la na frente */
                            if(res.dadosEnderecos.length > 0){
                                this.$store.dispatch("setDeliveryEndereco", res.dadosEnderecos[0])
                                this.buscarTaxasDeEntrega()
                            }
                            if(!this.retirarNoLocal){
                                if(!this.todosEnderecos.length){
                                    console.log("Cliente cadastrado mas sem endereços, navegando para cadastro de endereço")
                                    this.$router.push({ path: "/deliveryendereco", query: { novo:true, telefone: this.telefone }})
                                }
                                else {
                                    this.buscarTaxasDeEntrega()
                                }
                            }
                        })

                        /** caso retorne erro 501 eh pq o cliente ainda nao foi cadastrado */ 
                        .catch(err => {
                            console.log("erro aqui meu mano");
                            console.log(err);
                            this.loadingTelefone = false; 
                            this.voltouRespostaTelefone = true;
                            this.clienteExistente = false;

                            /** vamos limpar o state caso ja tenha alguma coisa la */
                            this.$store.dispatch("setDeliveryTaxas", null) 
                            this.$store.dispatch("setDeliveryEndereco", null) 
                            
                            /** vamos navegar para a pagina de cadastro de endereco */
                            this.$router.push({
                                path: "/deliveryendereco",
                                query: { novo:true, telefone: this.telefone },
                            })
                        })
                }
            } else {
                Swal.fire({title: "Telefone inválido"})
            }
        },


        /** 
         * o retorno do elemento TipoPagamento
         * @param {Object} data - { pagamentoId: number, trocoPara: string | number } 
         * 
         * SE o param {data} for = "mp", entao o usuario escoheu pagar pelo app. Isso pode ser verificado no template
         * usado a var { this.tipoPagamento.pagamentoId == "mp" }
         */
        callbackTipoPagamento(data) {
            console.log(data)
            this.tipoPagamento = data
        },

        
        /** 
         * o retorno do elemento EnderecoController
         * @param {Object} data - {retirarNoLocal: this.retirarNoLocal} 
         */
        callbackEnderecoController(data) {
            this.retirarNoLocal = data.retirarNoLocal
            this.$store.dispatch("setDeliveryRetirarNoLocal", data.retirarNoLocal)
            this.tipoPagamento = null

            // essa logica serva para caso o usuario ja tenha selecionado o endereco de entrega, gere o pix do MP
            // e depois ele queira mudar o endereco, dai tem que regenerar o pix
            let holder = this.pagarPeloApp
            this.pagarPeloApp = null
            setTimeout(() => {
                this.pagarPeloApp = holder

                console.log("cheguei aqui")
                console.log(data)
            }, 1000);


        },


        validarDados() {
            // se for pagar pelo app, nao precisamos das validacoes que esta funcao faz
            if (this.pagarPeloApp ) {
                return true
            }
            if (this.tipoPagamento == null) {
                Swal.fire({title: "Por favor, selecione o tipo de pagamento"})
                return false
            } else if (this.tipoPagamento.pagamentoId == null) {
                Swal.fire({title: "Por favor, selecione o tipo de pagamento"})
                return false
            } else if (this.tipoPagamento.trocoPara != null  && this.tipoPagamento.trocoPara != "" && parseFloat(this.tipoPagamento.trocoPara) < this.valorTotal()) {
                Swal.fire({title: "O valor do pagamento em dinheiro não pode ser inferior ao valor total do pedido."})
                return false
            } else {
                return true
            }
        },

        /**
         * Funcao chamada depois que o pagamento mp é finalizado.
         * @param {object}   paymentObject =
         *  {
                pix_data: this.pix_data,
                payment_id: this.pix_payment_id,
                payment_method_id: this.payment_method_id,
                data_pedido: new Date(),
            }
         */
        async onSubmitPagamentoMp(paymentObject) {
            // vamos colocar um timeout aqui pra ter certeza que a rota de verificar pagamento pix
            // ja parou de ser chamada
            setTimeout(() => {
                if (this.tipoPagamento == null) {
                    this.tipoPagamento = {}
                }

                if (paymentObject.payment_method_id != null) {
                    if (paymentObject.payment_method_id.includes("bank")) { // pix vem como 'bank_transfer'
                        this.tipoPagamento.pagamentoId = "web pix"
                        this.pixPaymentObjEnviarComPedido = paymentObject;
                    }
                    if (paymentObject.payment_method_id.includes("debi")) {
                        this.tipoPagamento.pagamentoId = "web debito"
                    }
                    if (paymentObject.payment_method_id.includes("cred")) {
                        this.tipoPagamento.pagamentoId = "web credito"
                    }
                }
                this.enviarPedido();
            }, 2000);
        },

        async onErrorPagamentoMp() {
            window.location.reload()
        },

        montarPedidoFinal() {
            let pedido = this.$store.state.deliveryPedido
            pedido.tipo = "delivery"

            let pedidoFinal = {
                idUnico: gerarIdUnico(),
                endereco: this.retirarNoLocal ? "retirar" : this.$store.state.deliveryEndereco,
                pagamento: this.tipoPagamento ??  "web pix",
                pedido: pedido,
                cnpj: this.$store.state.cnpj,
                empresaFK: this.$store.state.numeroEmpresaFK,
                numeroEmpresaFK: this.$store.state.numeroEmpresaFK,
                cliente: {id: this.dadosClienteApi.id ,telefone: this.telefone, nome: this.dadosClienteApi.nome, cpf: this.$store.state.cpfCliente},
                taxaEntrega: this.retirarNoLocal ? 0.0 : this.taxaDeEntrega?.TaxaEntrega,
                isHardRock: this.$store.state.isHardRock,
                dhPrevisaoEntrega: this.getFormattedDateEntrega(),
                valorTotalCarrinho: this.pedido.valorTotalCarrinho,
                created_at: new Date(),
                incluirCpfNaNota: this.incluirCpfNaNota,
                horarioCompra: this.getFormattedDate(), // para ver se a promocao ainda vaale. Formato: "2024-12-12 06:35:00"
                pix_dados: this.pixPaymentObjEnviarComPedido, // apenas para pedidos pix
            }
            return pedidoFinal
        },

        /**
         * retorna data formatada para verificar se a promocao ainda esta valida
         * @returns {string} data formatada "2024-12-12 06:35:00"
         */
         getFormattedDate() {
            const now = new Date();

            const year = now.getFullYear();
            const month = String(now.getMonth() + 1).padStart(2, '0'); // Months are zero-based
            const day = String(now.getDate()).padStart(2, '0');
            const hours = String(now.getHours()).padStart(2, '0');
            const minutes = String(now.getMinutes()).padStart(2, '0');
            const seconds = String(now.getSeconds()).padStart(2, '0');

            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        },

        /**
         * retorna data formatada para verificar se a promocao ainda esta valida
         * @returns {string} data formatada "2024-12-12 06:35:00"
         */
         getFormattedDateEntrega() {
            // previsao de entrega
            let prev = Number(this.$store.state.dhPrevisaoEntregaFinal) ?? 0


            const now = new Date();
            now.setMinutes(now.getMinutes() + prev)

            const year = now.getFullYear();
            const month = String(now.getMonth() + 1).padStart(2, '0'); // Months are zero-based
            const day = String(now.getDate()).padStart(2, '0');
            const hours = String(now.getHours()).padStart(2, '0');
            const minutes = String(now.getMinutes() ).padStart(2, '0');
            const seconds = String(now.getSeconds()).padStart(2, '0');

            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        },

        /**
         * Esta funcao vai montar a estrutura de dados do endereco e entao
         * vai enviar o pedido usando a funcaio @function apiEnviarPedido
         * que retornara uma Promise.
         */
        async enviarPedido() {
            const pagamentoPorPix = this.tipoPagamento.pagamentoId == "web pix";
            console.log(`pagamentoPorPix == ${pagamentoPorPix}`);
            try {
                if (this.validarDados()) {
                    this.loading = true
                    this.habilitarBotaoEnviar = false
                    let deliveryconfig = await ApiDelivery.verificarCasaEstaAbertaAgora(this.$store.state.cnpj, this.$store.state.numeroEmpresaFK, this.$store.state.idTerminal);

                    if (deliveryconfig.aberto) { 


                        /**
                         *  verificar se tem algum pedido em aberto e mostrar uma viso perguntando se o user quer continuar e faer um novo pedido mesmo assim
                         *  os possiveis status dos pedidos sao: "PRODUZINDO"  "ENTREGA"  "PRONTO RETIRADA"  "CONCLUIDO"  "CANCELADO"  "PAGAMENTO PENDENTE"  "PAGAMENTO NÃO EFETUADO"  "AGUARDANDO"
                         *  vamos parar o usuario caso o ultimo pedido tenha status "PRODUZINDO" ||  "PAGAMENTO PENDENTE" ||  "AGUARDANDO"
                         */
                        const pedidosAnteriroes = await ApiDelivery.buscarPedidos(this.$store.state.cnpj, this.telefone)
                        let continuarComEstePedido = true;

                        if (pedidosAnteriroes.length > 0) {
                            if (pedidosAnteriroes[0].status == "PRODUZINDO" || pedidosAnteriroes[0].status == "PAGAMENTO PENDENTE" || pedidosAnteriroes[0].status == "AGUARDANDO" ) {
                                await Swal.fire({
                                    title: "Você ainda tem um pedido com o status " + pedidosAnteriroes[0].status,
                                    text: "Deseja mesmo assim fazer um pedido novo?",
                                    allowOutsideClick: false,
                                    showConfirmButton: true,
                                    showCancelButton: true,
                                    confirmButtonText: "Continuar com este pedido",
                                    cancelButtonText: "Cancelar este pedido",
                                }).then(res => {
                                    if (res.isDenied || res.isDismissed) {
                                        continuarComEstePedido = false
                                    } else {
                                        continuarComEstePedido = true
                                    }
                                })
                            }
                        }

                        /** aqui vamos continuar com o pedido checando se {continuarComEstePedido} eh true */
                        if (continuarComEstePedido == true) {
                            
                            /** vamos montar o pedido */ 
                            let pedidoFinal = this.montarPedidoFinal()
                            console.log(pedidoFinal)

                            ApiDelivery.enviarPedido(pedidoFinal).then(res => {
                                
                                // caso seja pagamento por pix, vamos navegar direto para a tela de "meus pedidos" com o qrcode la
                                if (pagamentoPorPix) {
                                    this.$router.push({
                                        path: "/statusdelivery",
                                        // query: { novo:true, telefone: this.telefone },
                                    })
                                }
                                
                                console.log("res pedido final")
                                console.log(res)
                                this.pedidoEnviado = true
                                this.loading = false
                                this.$store.commit("SET_LIMPAR_ITENS_CARRINHO")
                            }).catch(err => {
                                console.log(err)
                                this.loading = false
                                Swal.fire({
                                    title: "Desculpe-nos!",
                                    text: "Ocorreu um erro. Por favor, verifique sua conexão e tente novamente mais tarde."
                                })
                            })
                        } else {
                            this.loading = false
                            this.$router.back();
                        }
                        
                    } else {
                        this.loading = false
                        let html = "O estabelecimento encontra-se <b>fechado</b> no momento!"
                        html += "<br><br>"
                        html += deliveryconfig.descricao
                        Swal.fire({
                            title: 'Desculpe-nos!',
                            html: html
                        })
                    }
                }
            } catch (error) {
                Swal.fire({
                    title: 'Desculpe-nos!',
                    html: error
                })
                this.$router.back();
            }
        },
        

        voltar() {
            this.$router.back();
        },
    },

    // eslint-disable-next-line vue/no-unused-components
    components: { MenuTopTemplate,  TelefoneComDDD, DadosEndereco, ControleEnderecos, TipoPagamento, DeliverySucessoView, MpPagamento, MpStatusScreenPix }
}
</script>

<style scoped>

.delivery-view-corpo {
    color: white;
}

p {margin: 2px}
.card {
    font-size: 15px;
    color: black; 
    margin-inline: 15px;
    border: white solid 2px;
    padding: 15px;
    border-radius: 5px;
    background: white;
    animation: card-anim 0.5s forwards;
}

@keyframes card-anim {
    from { opacity: 0; transform: translateX(-30%) }
    to { opacity: 1; transform: translateX(0%)}
}

.resumo-pedido span {
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    font-weight: bold;
}
.img-loading-container {
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
}
.img-loading {
    height: 7vh;
}

.input-btn {
    display: flex;
}
.input-btn input {
    width: 80%;
    margin-right: 10px;
}

.valor-pedido,
.valor-taxa,
.valor-tempo-entrega { font-size: 1.1rem ;}

.valor-total { font-weight: bold; font-size: 1.2rem ; }

.valor-pedido { color: var(--verde-claro); }
.valor-taxa { color: var(--valor-azul); }
.valor-total { color: var(--valor-verde); }
.valor-tempo-entrega { color: var(--valor-verde); min-width: 20%;text-align: end; }

@keyframes click-ic-anim {
    from {transform: scale(60%);}
    to {transform: scale(100%);}
}
.click-ic {
    animation: click-ic-anim 0.5s forwards;
    animation-timing-function: cubic-bezier(0.075, 0.82, 0.165, 1);
}




#mp-placeholder {
    height: 200px;
    width: auto;
    margin-inline: 15px;
    border-radius: 8px;
    background-color: white;
    display: flex;
    flex-direction: column;
    justify-items: center;
    align-items: center;
    justify-content: center;
    animation: mp-placeholder-anim 2s infinite; 
}
@keyframes mp-placeholder-anim {
    0%, 100% {opacity: 0.3;}
    40%, 60% {opacity: 1;}
}


</style>
